import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../client';

export const fetchDisabledFeatures = createAsyncThunk(
  'disabledfeatures/fetchDisabledfeatures',
  async () => {
    const res = await client.get(`/system/disabledfeatures`);
    return res;
  },
);